export default __webpack_public_path__ + "static/media/edit-mockups.ca0a6c4a.png";